import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  reloadAccessLog(_event) {
    this.accessLogTarget.reload()
  }

  get accessLogTarget() {
    return document.getElementById("key-locker-access-log")
  }
}
